// Resolves the assigned operator's real name for a given email by hitting
// /api/pollen/admin/team/resolve-name. Used by signatures, profile headers
// and task cards so shared inboxes (e.g. team@pollendots.com → Rishita Dey)
// surface the actual person, not the generic Google account name.
import { useEffect, useState } from 'react';
import { API } from '@/App';

const cache = new Map(); // email -> resolved name (or '' if not found)

export function useOperatorName(email, fallback = '') {
  const [name, setName] = useState(() => {
    if (!email) return fallback;
    const key = email.toLowerCase();
    return cache.has(key) ? (cache.get(key) || fallback) : fallback;
  });

  useEffect(() => {
    if (!email) { setName(fallback); return; }
    const key = email.toLowerCase();
    if (cache.has(key)) { setName(cache.get(key) || fallback); return; }
    const t = localStorage.getItem('session_token');
    fetch(`${API}/pollen/team/resolve-name?email=${encodeURIComponent(email)}`, {
      headers: t ? { Authorization: `Bearer ${t}` } : {},
      credentials: 'include',
    })
      .then(r => r.ok ? r.json() : null)
      .then(d => {
        const resolved = (d && d.name) ? d.name : '';
        cache.set(key, resolved);
        setName(resolved || fallback);
      })
      .catch(() => { setName(fallback); });
  }, [email, fallback]);

  return name;
}

// Build the standard Pollen Dots signature block for emails/WhatsApp
// templates. Pass the operator's resolved name; the rest is fixed.
export function pollenSignature(operatorName) {
  const op = (operatorName || '').trim() || 'Team Pollen Dots';
  return `${op}\nTeam Pollen Dots\nTravel · Connect · Care\nhttps://pollendots.com`;
}
